define.alias("shared/components/shared/plan-recommendation/steps/profiles", "media/components/shared/plan-recommendation/steps/profiles");